// extracted by mini-css-extract-plugin
export default {"container":"WP-z","title":"XP-z","link":"YP-z"};